// Hardcoded USPTO status codes from API
// Source: https://api.uspto.gov/api/v1/patent/status-codes
const statusCodes = [
  { code: 1, description: "Missassigned Application Number", alive: false },
  { code: 3, description: "Proceedings Terminated", alive: false },
  { code: 11, description: "Hague Application under International Review", alive: true },
  { code: 12, description: "Pre-Exam Transmittal Review Complete (Hague)", alive: true },
  { code: 16, description: "Waiting for LR clearance", alive: true },
  { code: 17, description: "Sent to Classification contractor", alive: true },
  { code: 18, description: "Application Returned back to Preexam", alive: true },
  { code: 19, description: "Application Undergoing Preexam Processing", alive: true },
  { code: 20, description: "Application Dispatched from Preexam, Not Yet Docketed", alive: true },
  { code: 21, description: "Lost Image Document Mailed",    alive: false },
  { code: 30, description: "Docketed New Case - Ready for Examination",     alive: true },
  { code: 40, description: "Non-Final Action Mailed", alive: true },
  { code: 45, description: "Non-Final Rejection Counted, Not yet Mailed", alive: true },
  { code: 50, description: "Response to Non-Final Office Action Entered and Forwarded to Examiner", alive: true },
  { code: 60, description: "Final Rejection Mailed", alive: true},
  { code: 65, description: "Final Rejection Counted, Not yet Mailed", alive: true },
  { code: 70, description: "Response After Final Action Forwarded to Examiner", alive: true },
  { code: 71, description: "Request for Continued Examination Filed",   alive: true },
  { code: 80, description: "Notice of Allowance Mailed - Application Received in Office of Publications",   alive: true },
  { code: 85, description: "Issue Fee Payment Received", alive: true },
  { code: 86, description: "Issue Fee Payment Verified", alive: true },
  { code: 90, description: "Abandoned - Failure to Respond to an Office Action", alive: false },
  { code: 91, description: "Abandoned - Express", alive: false },
  { code: 92, description: "Abandoned - Incomplete Application (Pre-examination)", alive: false },
  { code: 93, description: "Abandoned - After Allowance", alive: false },
  { code: 94, description: "Abandoned - After Final Rejection", alive: false },
  { code: 95, description: "Abandoned - Non Payment of Issue Fee", alive: false },
  { code: 96, description: "Abandoned - IDS Questions", alive: false },
  { code: 97, description: "Abandoned - After Non-Final Rejection", alive: false },
  { code: 98, description: "Abandoned - After Examiner's Answer", alive: false },
  { code: 99, description: "Abandoned - Following Submission of Amendment Under 37 CFR 1.312", alive: false },
  { code: 100, description: "Publications - Issue Fee Payment Verified", alive: true },
  { code: 101, description: "Patented Case", alive: true },
  { code: 150, description: "Docketed New Case - Ready for Pre-Appeal Conference", alive: true },
  { code: 151, description: "Pre-Appeal Brief Conference Decision Mailed", alive: true },
  { code: 152, description: "Pre-Appeal Brief Conference Examiner Reopens Application", alive: true },
  { code: 153, description: "Pre-Appeal Brief Conference - Examiner Maintains Rejection", alive: false },
  { code: 154, description: "Appeal Brief Filed", alive: true },
  { code: 155, description: "Examiner's Answer to Appeal Brief Mailed", alive: true },
  { code: 156, description: "Reply Brief Filed", alive: true },
  { code: 157, description: "Notice of Appeal Filed", alive: true },
  { code: 158, description: "On Appeal - Board of Patent Appeals and Interferences", alive: true },
  { code: 159, description: "Appeal Decision Rendered by Board of Patent Appeals and Interferences", alive: true },
  { code: 160, description: "Board of Patent Appeals Reversed Examiner's Rejection", alive: true },
  { code: 161, description: "Board of Patent Appeals Affirmed Examiner's Rejection", alive: false },
  { code: 162, description: "Board of Patent Appeals - Decision Modified", alive: true },
  { code: 163, description: "Board of Patent Appeals - Decision Vacated", alive: true },
  { code: 200, description: "Petition Filed and Application Awaiting Action", alive: true },
  { code: 201, description: "Petition Granted", alive: true },
  { code: 202, description: "Petition Dismissed", alive: true },
  { code: 250, description: "Application under Interference", alive: true }
];

export default statusCodes;
